/**
 * Enum for fiscal docs provider.
 * @readonly
 * @enum {String} FiscalDocsProviderEnum
 */

const FiscalDocsProviderEnum = {
  IMPACT : 'impact',
  GENERIC: 'generic',
  NONE   : ''
}

export default FiscalDocsProviderEnum
